import { List } from "hooks/useHandleObjList"

export const mapProductToSubmition = (
  productForm: App.ProductForm,
  benefitsList: List<App.IBenefitItem>
): App.ProductPayload => {
  return {
    product: {
      name: productForm.name,
      prefixUrl: productForm.prefixUrl,
      isFederated: productForm.isFederated,
      isExternal: productForm.isExternal,
      federatedKey: productForm.federatedKey,
      federationFields: productForm.federationFields,
      productInfo: productForm.productInfo,
      marketplaceInfo: {
        ...productForm.marketplaceInfo,
        benefits: benefitsList.map((benefit) => benefit.value)
      }
    },
    filesObj: productForm.files
  }
}
